import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { updateLoadingState } from '@sales-center/common'
import {
  useGetSalesFunnelListOnMount,
  useGetAllFunnelStagesOnMount,
} from '@user/store/salesFunnel/hooks'
import { selectAllOpportunities } from '@user/store/opportunity/slice'
import { useGetAppointmentsDataOnMount } from '@user/store/scheduling'

export function useGetData(oppsLoading: boolean) {
  const dispatch = useAppDispatch()
  const funnelStatus = useGetSalesFunnelListOnMount()
  const stageStatus = useGetAllFunnelStagesOnMount()

  const opps = useSelector(selectAllOpportunities)

  const { appointmentsLoading, appointmentsMap } =
    useGetAppointmentsDataOnMount(0, opps)

  const loading =
    oppsLoading || funnelStatus === 'pending' || stageStatus === 'pending'

  useEffect(() => {
    dispatch(updateLoadingState(loading ? 'visible' : 'hidden'))
  }, [dispatch, loading])

  return {
    opps,
    appointmentsMap,
    appointmentsLoading,
  }
}
